import { render, staticRenderFns } from "./CalendarSyncDialog.vue?vue&type=template&id=52a10254&scoped=true&"
import script from "./CalendarSyncDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarSyncDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarSyncDialog.vue?vue&type=style&index=0&id=52a10254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a10254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VTextField,VToolbar,VToolbarTitle})
